import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import StripeForm from './StripeForm';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_CLIENT_ID);

const Stripe = (props) => {
  const { cartData } = props;

  const price = ((cartData?.usedBonus === null || cartData?.usedBonus === '') ? parseFloat(cartData?.price) : parseFloat(cartData?.priceDiscount));
  const productId = cartData.id;
  const productName = cartData.title;
  const registrationCode = cartData.registrationCode;
  const productCode = cartData.code;

  return (
    <Elements stripe={stripePromise}>
      <StripeForm
        productId={productId}
        productName={productName}
        price={price*100}
        registrationCode={registrationCode}
        productCode={productCode}
      />
    </Elements>
  );
};

export default Stripe;
